import { render, staticRenderFns } from "./collectConfirmation.vue?vue&type=template&id=137f55e1&scoped=true"
import script from "./collectConfirmation.vue?vue&type=script&lang=js"
export * from "./collectConfirmation.vue?vue&type=script&lang=js"
import style0 from "./collectConfirmation.vue?vue&type=style&index=0&id=137f55e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f55e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137f55e1')) {
      api.createRecord('137f55e1', component.options)
    } else {
      api.reload('137f55e1', component.options)
    }
    module.hot.accept("./collectConfirmation.vue?vue&type=template&id=137f55e1&scoped=true", function () {
      api.rerender('137f55e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/collectConfirmation.vue"
export default component.exports